import AxiosClient from "../../../services/axios.services";

class DashboardJefeServices {
  getDashboardJefe = (params, id) =>
    AxiosClient.get("/api/app/dashboard_evaluaciones_jefe/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
}

export default new DashboardJefeServices();
